import { useApiMutation } from './useApiMutation';
import { queryKeys } from './queryKeys';
import { DrawdownCalculationService } from '@/services/drawdowns/drawdownCalculationService';
import { APIError } from '@/utils/api-client';
import type {
  DrawdownCalculateRequest,
  DrawdownCalculationResult,
  DrawdownCreateRequest,
  DrawdownCreateResponse,
} from '@/services/drawdowns/drawdownCalculationService';

// Mutation for calculating drawdown allocations
export const useCalculateDrawdown = () => {
  return useApiMutation<
    DrawdownCalculationResult,
    APIError,
    {
      fundId: string;
      request: DrawdownCalculateRequest;
    }
  >(
    ({ fundId, request }) =>
      DrawdownCalculationService.calculateDrawdown(fundId, request),
    {
      // Don't invalidate cache on calculation, this is just a preview
      showSuccessToast: false,
      errorMessage: 'Failed to calculate drawdown allocations',
    }
  );
};

// Mutation for creating drawdown with pre-calculated allocations
export const useCreateDrawdownWithAllocations = () => {
  return useApiMutation<
    DrawdownCreateResponse,
    APIError,
    {
      fundId: string;
      request: DrawdownCreateRequest;
    }
  >(
    ({ fundId, request }) =>
      DrawdownCalculationService.createDrawdown(fundId, request),
    {
      invalidateKeys: (_data, variables) => [
        queryKeys.drawdowns.all,
        queryKeys.capitalCalls.all,
        queryKeys.funds.detail(variables.fundId),
        queryKeys.funds.investors(variables.fundId),
        queryKeys.prepaymentPool.all,
        queryKeys.metrics.dashboard(),
      ],
      successMessage: 'Drawdown created successfully',
    }
  );
};
